export default "__VITE_ASSET__PZire47Z__"